import React, { useState, useEffect } from "react";
const staticMessage = "Download content will be available in"
const CountdownMessage = ({message = staticMessage, style={},setDownloadAvailable=()=>{},countValue = 10}) => {
  const [count, setCount] = useState(countValue);
  const [showMessage, setShowMessage] = useState(true);

  useEffect(() => {
    if (!showMessage) return;

    const timerId = setInterval(() => {
      setCount((prevCount) => {
        if (prevCount <= 1) {
          clearInterval(timerId);
          setShowMessage(false);
          setDownloadAvailable(true); // Notify that download is available
        //   return 0;
        }
        return prevCount - 1;
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, [showMessage]);

  return <>{showMessage && <p style={{color:'brown',fontSize:"14px",...style}}> {message} <span translate="no">{count} {" "}</span> seconds</p>}</>;
};

export default CountdownMessage;
